import { Component, OnInit, ViewChild } from '@angular/core';
import { AdministrationCheckout, Appointment, AppointmentHistory, AppointmentSummary, Lookups, Patient, PopupButton, PopupModel, PopupModelReturn, PopupSetupModel, ServiceAreas, Staff } from '../../AllTableClasses';
import { PopupNotificationService } from '../../Services/popup-notification.service';
import { MembersService } from '../../Services/members.service';
import { LookupsService } from '../../Services/lookups.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationPopupComponent } from '../Components/notification-popup/notification-popup.component';
import { CheckoutPopupComponent } from '../Components/checkout-popup/checkout-popup.component';
import { SchedulerService } from '../../Services/scheduler.service';
import UserSession from '../../Config/user-session';
import { StaffService } from '../../Services/staff.service';

@Component({
  selector: 'app-appointment-summary',
  templateUrl: './appointment-summary.component.html',
  styleUrl: './appointment-summary.component.scss'
})
export class AppointmentSummaryComponent implements OnInit {
  public patient: Patient = new Patient();
  public appointment: AppointmentSummary = new AppointmentSummary();
  appointmentSet: Appointment = new Appointment();
  public appointmentID!: number;
  public appointmentHistory: Array<AppointmentHistory> = new Array<AppointmentHistory>();
  public times: Array<Lookups> = new Array<Lookups>();
  public staffList: Array<Staff> = new Array<Staff>();
  public audioligsts: Array<Staff> = new Array<Staff>();

  public serviceAreas: Array<ServiceAreas> = new Array<ServiceAreas>();
  public durationInMinutes!: number;

  events: any[] = [];
  public showError: boolean = false;
  public erroMessage!: string;

  @ViewChild('popup') popup!: NotificationPopupComponent;
  @ViewChild('checkoutPopup') checkoutPopup!: CheckoutPopupComponent;

  constructor(
    private popupNotificationService: PopupNotificationService,
    private membersService: MembersService,
    private schedulerService: SchedulerService,
    private lookupService: LookupsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private staffService: StaffService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.appointmentID = params['result'];
      if (this.appointmentID == null || this.appointmentID == undefined) {
      }
      else {
        this.TimesGet();
        this.AppointmentSummaryGetByID();
        this.StaffGet();
        this.eventsGet();
        this.ServiceAreasGet();

      }

    }).unsubscribe();
  };

  public StaffGet() {
    this.staffService.StaffSearch("", false, null, null, null, (data) => {
      if (data.Success) {
        this.staffList = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public audiologistGetByBranchID() {
    this.staffService.StaffGetByBranchID(this.appointment.BranchID, (data: any) => {
      if (data.Success) {
        this.audioligsts = data.Data;
      } else {
        console.error('Error fetching doctors:', data.Message);
      }
    }, (error: any) => { });
  }
  public appointmentHistoryGet() {
    this.schedulerService.AppointmentHistoryGet(this.appointmentID, (data) => {
      if (data.Success) {
        this.appointmentHistory = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public AppointmentSummaryGetByID() {
    this.schedulerService.AppointmentSummaryGetByID(this.appointmentID, (data) => {
      if (data.Success) {
        this.appointment = data.Data;
        this.audiologistGetByBranchID();
        this.calculateDuration();
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public TimesGet() {
    this.lookupService.TimesGet((data) => {
      if (data.Success) {
        this.times = data.Data;
      }
      else {

      }
    }, (error) => { })
  };

  public ServiceAreasGet() {
    this.schedulerService.ServiceAreasGetByBranchID(UserSession.BranchID, (data: any) => {
      if (data.Success) {
        this.serviceAreas = JSON.parse(data.Data);

      } else {
        console.error('Error fetching serviceAreas:', data.Message);
      }
    }, (error: any) => { });
  }

  public CancelAppointment() {
    let notificationPopup: PopupModel = new PopupModel();
    notificationPopup.Message = 'Are you sure you want to cancel this appointment';
    notificationPopup.MessageType = 'error';
    notificationPopup.Button = new PopupButton('Yes', 'Confirm');
    notificationPopup.AltButton = new PopupButton('No', 'Cancel');

    this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => {
      if (res.Result === 'Confirm') {
        this.CancelAppointmentSet();
      }
    });
  }

  public CancelAppointmentSeries() {
    let notificationPopup: PopupModel = new PopupModel();
    notificationPopup.Message = 'Do you want to cancel this appointment series?';
    notificationPopup.MessageType = 'error';
    notificationPopup.Button = new PopupButton('Yes', 'Confirm');
    notificationPopup.AltButton = new PopupButton('No', 'Cancel');

    this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => {
      if (res.Result === 'Confirm') {
        this.CancelAppointmentSeriesSet();
      }
      else {
        this.CancelAppointment();
      }
    });
  }

  public CancelAppointmentSet() {
    let appointmentCheckout = new AdministrationCheckout();
    appointmentCheckout.AppointmentID = this.appointment.ID;
    appointmentCheckout.CheckoutStatus = 'Cancelled';
    appointmentCheckout.ModifySeries = false;

    this.schedulerService.AppointmentStatusSet(appointmentCheckout, (data) => {
      if (data.Success) {
        this.showNotifcationPopup(data.Success);
      }
      else {
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public CancelAppointmentSeriesSet() {
    let appointmentCheckout = new AdministrationCheckout();
    appointmentCheckout.AppointmentID = this.appointment.ID;
    appointmentCheckout.CheckoutStatus = 'Cancelled';
    appointmentCheckout.ModifySeries = true;

    this.schedulerService.AppointmentStatusSet(appointmentCheckout, (data) => {
      if (data.Success) {
        this.showNotifcationPopup(data.Success);
      }
      else {
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { });
  }


  public AdminCheckout()
  {
    let service_Popup: PopupSetupModel = new PopupSetupModel();
    service_Popup.Title = 'Administration';
    service_Popup.PopupAction = 'Administration';
    service_Popup.Data = this.appointment;
    service_Popup.Button = new PopupButton('Finalize Checkout', 'Confirm');

    this.popupNotificationService.ShowCheckoutPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Confirm') {
        this.AdministrationCheckoutSet(res.Data);
      }
      else {
      }
    });
  }

  public AdministrationCheckoutSet(appointmentCheckout: AdministrationCheckout) {
    this.schedulerService.AdministrationCheckoutSet(appointmentCheckout, (data) => {
      if (data.Success) {
        this.showNotifcationPopup(data.Success);
      }
      else {
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { });
  }


  public AudiologistCheckout()
  {
    let service_Popup: PopupSetupModel = new PopupSetupModel();
    service_Popup.Title = 'Audiologist';
    service_Popup.PopupAction = 'Audiologist';
    service_Popup.Data = this.appointment;
    service_Popup.Button = new PopupButton('Finalize Checkout', 'Confirm');

    this.popupNotificationService.ShowCheckoutPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Confirm') {
        this.AudiologistCheckoutSet(res.Data.appointmentCheckout, res.Data.patient);
      }
      else {
      }
    });
  }

  public AudiologistCheckoutSet(appointmentCheckout: AdministrationCheckout, patient: Patient)
  {
    this.schedulerService.AudiologistCheckoutSet(appointmentCheckout, (data) => {
      if (data.Success)
      {
        patient.Status = 'OLD PATIENT';
        this.MemberSetByGuid(patient);
        //this.showNotifcationPopup(data.Success);
      }
      else
      {
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);

      }
    }, (error) => { });
  }


  public MemberSetByGuid(patient: Patient) {

    this.membersService.MemberSetByGuid(patient, (data) => {
      if (data.Success)
      {
          this.showNotifcationPopup(data.Success);
      }
      else
      {
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { console.log(error); });
  }

  public UpdateAppointment() {

    if (this.appointment.StartTime == undefined || this.appointment.StartTime == '') {
      this.showError = true;
      this.erroMessage = 'Please select a start time';
      this.showNotifcationPopup(false, this.erroMessage);
      return;
    }

    if (this.appointment.EndTime == undefined || this.appointment.EndTime == '') {
      this.showError = true;
      this.erroMessage = 'Please select a end date';
      this.showNotifcationPopup(false, this.erroMessage);
      return;
    }

    if (this.appointment.StartDate == undefined || this.appointment.StartDate == '') {
      this.showError = true;
      this.erroMessage = 'Please select a date';
      this.showNotifcationPopup(false, this.erroMessage);
      return;
    } else {
      this.TimeSelectionValidation();
    }

    this.appointmentSet.AppointmentID = this.appointment.ID;
    this.appointmentSet.StaffMemberID = this.appointment.AllocatedUserID;
    this.appointmentSet.PatientID = this.appointment.PatientID;
    this.appointmentSet.StartDate = this.appointment.StartDate + ' ' + this.appointment.StartTime;
    this.appointmentSet.EndDate = this.appointment.StartDate + ' ' + this.appointment.EndTime;
    this.appointmentSet.ServiceProviderID = this.appointment.ServiceProviderID;
    this.appointmentSet.AppointmentNotes = this.appointment.AppointmentNotes;
    this.appointmentSet.IsEmployeeMeeting = this.appointment.IsEmployeeMeeting;

    const conflictResult = this.hasConflict(this.appointmentSet);

    if (conflictResult.hasConflict) {

      const conflictMsg = `Conflict with "${conflictResult.conflictingEvent?.ServiceName}" scheduled from ${this.formatDate(
        conflictResult.conflictingEvent?.startDate
      )} to ${this.formatDate(conflictResult.conflictingEvent?.endDate)}.`;
      this.showError = true;
      this.erroMessage = conflictMsg;
      this.showNotifcationPopup(false, conflictMsg);
      return;
    }

    this.schedulerService.AppointmentSet(this.appointmentSet, UserSession.BranchID, (data: any) => {
      if (data.Success) {
        this.showNotifcationPopup(data.Success);
      }
      else
      {
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error: any) => { });
  }

  public eventsGet() {
    this.schedulerService.EventsGet(this.appointment.BranchID, (data: any) => {
      if (data.Success) {
        this.events = JSON.parse(data.Data);
      } else {
        console.error('Error fetching events:', data.Message);
      }
    }, (error: any) => { });
  }

  public showNotifcationPopup(success: boolean, message?: string) {
    let notificationPopup: PopupModel = new PopupModel();
    notificationPopup.Message = 'Appointment has been successfully updated';
    notificationPopup.MessageType = 'success';
    notificationPopup.Button = new PopupButton('Calendar', 'routeToCalendar');
    //notificationPopup.AltButton = new PopupButton('Home', 'routeToHome');

    if (success == true) {
      this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => {
        if (res.Result === 'routeToCalendar') {
          this.router.navigate(['scheduler']);
        }
      });
    }
    else {
      notificationPopup.Message = message;
      notificationPopup.MessageType = 'error';
      this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => { });
    }

  }

  public hasConflict(appointment: Appointment): { hasConflict: boolean; conflictingEvent?: any } {
    const conflict = this.events.find(event => {
      // Ensure the IDs are not the same to avoid an appointment conflicting with itself
      if (event.id !== appointment.AppointmentID && event.resourceId === appointment.StaffMemberID) {
        const existingStart = new Date(event.startDate).getTime();
        const existingEnd = new Date(event.endDate).getTime();
        const newStart = new Date(appointment.StartDate).getTime();
        const newEnd = new Date(appointment.EndDate).getTime();

        // Check for overlap
        return newStart < existingEnd && newEnd > existingStart;
      }
      return false;
    });

    if (conflict) {
      return { hasConflict: true, conflictingEvent: conflict };
    }
    return { hasConflict: false };
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString(); // Format date as 'MM/DD/YYYY, HH:MM:SS'
  }

  public addMinutesToTime(timeString: string, minutesToAdd: number) {
    // Convert "08:00" to a Date object
    const [hours, minutes] = timeString.split(':');
    const date = new Date();
    date.setHours(parseInt(hours));
    date.setMinutes(parseInt(minutes));

    // Add the desired minutes
    date.setMinutes(date.getMinutes() + minutesToAdd);

    // Format the updated time back to "HH:mm"
    const updatedHours = date.getHours().toString().padStart(2, '0');
    const updatedMinutes = date.getMinutes().toString().padStart(2, '0');

    return `${updatedHours}:${updatedMinutes}`;
  }

  public TimeSelectionValidation() {

    if (this.appointment.StartTime && this.appointment.EndTime) {
      let startTime = this.parseTime(this.appointment.StartTime);
      let endTime = this.parseTime(this.appointment.EndTime);

      if (startTime >= endTime) {
        this.showError = true;
        this.erroMessage = 'Start time must be after the end time';
        return;
      }
      else {
        this.showError = false;
      }
    }

  }

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // This makes the scrolling smooth
    });
  }

  calculateDuration(): number {
    const start = this.parseTime(this.appointment.StartTime);
    const end = this.parseTime(this.appointment.EndTime);

    this.durationInMinutes = (end.hours * 60 + end.minutes) - (start.hours * 60 + start.minutes);
    console.log('Duration: ' + this.durationInMinutes);
    return this.durationInMinutes;
  }

  onStartTimeChange(): void {

    // Recalculate the end time based on the original duration
    const duration = this.durationInMinutes;
    const updatedStart = this.parseTime(this.appointment.StartTime);

    const newEndHours = Math.floor((updatedStart.hours * 60 + updatedStart.minutes + duration) / 60);
    const newEndMinutes = (updatedStart.hours * 60 + updatedStart.minutes + duration) % 60;

    this.appointment.EndTime = this.formatTime(newEndHours, newEndMinutes);
  }

  private parseTime(time: string): { hours: number, minutes: number } {
    const [hours, minutes] = time.split(':').map(Number);
    return { hours, minutes };
  }


  private formatTime(hours: number, minutes: number): string {
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}`;
  }
}
